import React, {} from 'react';

import Carousel from '../../components/Carousel/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from "../../components/Navbar/Navbar";
import classes from './Home.module.css';
import AboutUs from "../../components/AboutUs/AboutUs";
import Foot from "../../components/Foot/Foot";
import Announcement from "../../components/Announcement/Announcement";
import Featured from "../../components/Featured/Featured";

function Home(){
  
    return(
        <div className={classes.container}>
          

                    
        <Navbar className={classes.Nav}/>
        {/* <Announcement/> */}
     
        <div><Carousel /></div>
        
        <div className={classes.box}>
        

      
        <Featured className={classes.feat} title="FEATURED PRODUCTS"/>


        <AboutUs className={classes.aboutUs}/>
        

        </div>

       
       
                

        <Foot/>
      </div>
    )
}


export default Home;   